import React from 'react'
import SideNav from '../../layouts/side-nav.js'

import './style/questions.css'

const components = ['why', 'press', 'history', 'questions', 'case-study', 'lease-loan', 'good-business']

export default (props) => (
  <div>
    <div className='questions-hero'>
      <div className='questions-hero-img' />
    </div>
    <div className='questions-title'>
      10 Questions
    </div>
    <div className='questions-content'>
      <SideNav components={components} base='why' current='questions' />
      <p>
        The Equipment Leasing Association recommends businesses ask the following 10 questions before signing a lease. These questions take into account the "before, during and after" stages of a lease.
      </p>
      <ol>
        <strong>Before</strong>
        <li>
          How am I planning to use this equipment in my business and how long will I need it?
        </li>
        <li>
          Does the leasing representative understand my business and how this transaction helps me do business?
        </li>
        <strong>During</strong>
        <li>
          What is the total lease payment and are there any other costs that I could incur before the lease ends?
        </li>
        <li>
          What happens if I want to change this lease or end the lease early?
        </li>
        <li>
          How am I responsible if the equipment is damaged or destroyed?
        </li>
        <li>
          What are my obligations for the equipment (such as insurance, taxes and maintenance) during the lease?
        </li>
        <li>
          Can I upgrade the equipment or add equipment under this lease?
        </li>
        <strong>After</strong>
        <li>
          What are my options at the end of the lease?
        </li>
        <li>
          What are the procedures I must follow if I choose to return the equipment?
        </li>
        <li>
          Are there any extra costs at the end of the lease?
        </li>
      </ol>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/pages/why/questions.js